'use strict';

const processInclude = require('progamers_core/util');

$(document).ready(function () {
    processInclude(require('./components/search'));
});
